import { MAPBOX_BLUEPRINT_ELEVATED_LAYER_ID } from '../map.constants';
import { MAP_THREEJS_LAYER_IDS } from './map-config.constants';

/**
 * Custom WebGL overlay ids. Presence of all of these lets the three.js map
 * skip restack on Mapbox `styledata`.
 */
export const MAP_THREEJS_CUSTOM_LAYER_IDS = [
  MAP_THREEJS_LAYER_IDS.facadeSky,
  MAP_THREEJS_LAYER_IDS.pointDragGuides,
  MAP_THREEJS_LAYER_IDS.extrusion,
  MAP_THREEJS_LAYER_IDS.wireframe,
  MAP_THREEJS_LAYER_IDS.silhouette,
  MAP_THREEJS_LAYER_IDS.points,
] as const;

/**
 * Bottom → top under GeoJSON symbol points.
 * Overlay points last so they sit above the silhouette after restack.
 */
export const MAP_THREEJS_LAYER_ORDER_STACK = [
  MAP_THREEJS_LAYER_IDS.facadeSky,
  MAPBOX_BLUEPRINT_ELEVATED_LAYER_ID,
  MAP_THREEJS_LAYER_IDS.extrusion,
  MAP_THREEJS_LAYER_IDS.wireframe,
  MAP_THREEJS_LAYER_IDS.pointDragGuides,
  MAP_THREEJS_LAYER_IDS.silhouette,
  MAP_THREEJS_LAYER_IDS.points,
] as const;
